import { useNavigate, useSearch } from '@tanstack/react-router'
import { resolvePostLoginPath, type RedirectUser } from 'shared/post-login'

// Destination logic is shared with the server OAuth callback (shared/post-login) so the two cannot drift.
export function usePostLoginRedirect() {
  const navigate = useNavigate()
  const { redirect } = useSearch({ strict: false })

  return (user: RedirectUser) => {
    const dest = resolvePostLoginPath(user, { redirect })
    if ('href' in dest) navigate({ href: dest.href, replace: true })
    else navigate({ to: dest.to, replace: true })
  }
}
